import React from "react";
import {
  Home,
  Building2,
  Truck,
  Package,
  Trash2,
  Wrench,
  ArrowUpRight,
} from "lucide-react";

const ICONS = [Home, Building2, Truck, Package, Trash2, Wrench];

export default function Services({ t }) {
  return (
    <section id="services" className="bg-white border-b-2 border-black" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-8 md:gap-12 mb-10 md:mb-14">
          <div className="md:col-span-5">
            <div className="text-xs font-bold tracking-[0.22em] text-[#E11D2E]">{t.services.eyebrow}</div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1]">
              {t.services.title}
            </h2>
          </div>
          <div className="md:col-span-7 md:pt-4">
            <p className="text-base md:text-lg text-zinc-700 leading-relaxed">
              {t.services.subtitle}
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-0 border-2 border-black">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <a
                key={i}
                href="#quote"
                className="group relative p-7 md:p-8 border-black bg-white hover:bg-[#0A0A0A] hover:text-white transition-colors border-r-2 border-b-2 last:border-r-2 [&:nth-child(3n)]:border-r-0 [&:nth-last-child(-n+1)]:border-b-0 md:[&:nth-last-child(-n+2)]:border-b-0 lg:[&:nth-last-child(-n+3)]:border-b-0"
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-start justify-between">
                  <Icon size={36} strokeWidth={1.25} className="text-[#E11D2E]" />
                  <ArrowUpRight
                    size={22}
                    className="opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
                  />
                </div>
                <div className="mt-8 font-display text-2xl md:text-3xl leading-[1]">
                  {s.title}
                </div>
                <p className="mt-3 text-sm leading-relaxed opacity-80">{s.desc}</p>
                <div className="mt-6 text-[10px] font-bold tracking-[0.22em] opacity-70">
                  0{i + 1} / 0{t.services.items.length}
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
